<template>
  <section id="experiences" class="rn-experience-area section-separator rn-section-gap">
    <!-- Start Experience area -->
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" class="section-title text-center">
              <span class="subtitle">Over 3+ years of experience</span>
              <h2 class="title">My Experience</h2>
            </div>
          </div>
        </div>
        <div class="row mt--10">
          <div class="col-12 mt_experience">

            <!-- single skills -->
            <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" class="experience-style-two">
              <div class="w-25">
                <div class="experience-image">
                  <img src="@/assets/images/portfolio/experience1.png" alt="Personal Portfolio" loading="lazy">
                </div>

              </div>
              <div class="w-75">
                <div class="experience-center">
                  <span class="date bg-success">July 2023-Present</span>
                  <h4 class="experience-title">
                    Antimonopoly Committee of Uzbekistan - FAIRTECH
                  </h4>
                  <h6 class="subtitle">
                    Full Stack Java Engineer
                  </h6>
                  <p class="disc">Developed scalable web applications to support market regulation</p>
                  <a class="rn-btn rn-btn-small float-end" target="_blank" href="https://raqobat.gov.uz/uz/raqobat-qomitasining-fair-tech-yagona-axborot-tizimi-orqali-respublikamizning-hududlari-kesimida-farmatsevtika-faoliyati-bilan-shugullanuvchi/"><span>VIEW MORE</span></a>
                </div>
                <div class="experience-footer">
                </div>
              </div>
            </div>
            <!-- single skills -->

            <!-- single skills -->
            <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" class="experience-style-two">
              <div class="w-25">
                <div class="experience-image">
                  <img src="@/assets/images/portfolio/experience2.png" alt="Personal Portfolio" loading="lazy">
                </div>

              </div>
              <div class="w-75">
                <div class="experience-center">
                  <span class="date bg-danger">May 2022 - June2023 </span>
                  <h4 class="experience-title">
                    Texno Model
                  </h4>
                  <h6 class="subtitle">
                    Java Software Engineer
                  </h6>
                  <p class="disc">Led backend development and partially managed projects.</p>

                  <p class="disc">Developed ERP modules and integrated backend logic.</p>
                  <a class="rn-btn rn-btn-small float-end" target="_blank" href="http://teda.uz/"><span>VIEW MORE</span></a>
                </div>
                <div class="experience-footer">
                </div>
              </div>
            </div>
            <!-- single skills -->

          </div>
        </div>
      </div>
    <!-- End Experience area -->
  </section>
</template>

<script>

export default {
  name: 'ExperienceSection',
  data() {
    return {}
  }
}
</script>
